import { FlowGrid, useContainerWidth } from '@fs/zion-ui'
import React from 'react'

export default function ArtifactCardGrid({ children }) {
  const atWidth = useContainerWidth()
  return (
    <FlowGrid
      columnCount={atWidth({
        default: 4,
        nano: 1,
        xxs: 1,
        xs: 1,
        sm: 2,
        md: 2,
        lg: 2,
        xl: 3,
        xxl: 4,
      })}
    >
      {children}
    </FlowGrid>
  )
}
